import { useState } from 'react'
import useInView from '../../hooks/useInView'
import { WrapperProps } from './Wrapper.types'

const Wrapper: React.FC<WrapperProps> = ({ className, id, children }) => {
	const [isSectionShown, setIsSectionShown] = useState(false)

	const { ref: sectionRef, inView: sectionInView } = useInView({
		threshold: 0.2,
	})

	if (sectionInView && !isSectionShown) {
		setIsSectionShown(true)
	}

	return (
		<section className={`${className} ${className}${isSectionShown ? '--shown' : '--hidden'}`} ref={sectionRef} id={id}>
			{children}
		</section>
	)
}

export default Wrapper
